import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { SlideUpTransition } from '../Transitions/Transitions';
import BaseDialog from './BaseDialog';

const ContractDebtInfoDialog = props => {
  const { open = true, onClose, title = 'Título', content = null } = props;
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <BaseDialog
      open={open}
      handleClose={onClose}
      title={title}
      actions={() => null}
      content={content}
      fullScreen={isMobileSize}
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
    />
  );
};

export default ContractDebtInfoDialog;
